import { registerEnumType } from 'type-graphql'

export enum CustomerLayoutChoiceEnum {
  TREE = 'TREE',
  LIST = 'LIST',
}

registerEnumType(CustomerLayoutChoiceEnum, {
  name: 'CustomerLayoutChoiceEnum',
  description: 'Available customer layout choices',
})

export const CustomerLayoutChoiceMetadata = {
  [CustomerLayoutChoiceEnum.TREE]: {
    name: 'Tree View',
    description: 'Hierarchical tree view showing companies and customers',
  },
  [CustomerLayoutChoiceEnum.LIST]: {
    name: 'List View',
    description: 'Flat list view with expandable company rows',
  },
}
